const Footer = () => {
    return (
      <footer className="main-footer">
        <div className="footer-left">
          <a href="/dashboard">Website</a>
        </div>
        <div className="footer-right"></div>
      </footer>
    );
  };
  
  export default Footer;
  